import { ChipGroup, TextArea } from "@newsela/angelou";
import { useState, useCallback } from "react";

import { AIChip } from "@/components/AIComponents/AIChip";
import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import AIBetaTag from "@/components/AIComponents/AIBetaTag/AIBetaTag";
import AIButton from "@/components/AIComponents/AiButton";
import AIToggle from "@/components/AIComponents/AIToggle";
import LunaPeekingSideIcon from "@/icons/LunaPeekingSideIcon/LunaPeekingSideIcon";
import {
  LUNA_RESULTS_MOCK,
  LUNA_FILTER_PANEL_TEST_IDS,
} from "./LunaFilterPanel.constants";
import { LunaFilterPanelProps } from "./LunaFilterPanel.types";
import {
  lunaFilterPanelContainerCss,
  lunaContentContainerCss,
  lunaTagsContainerCss,
  lunaResultsHeaderCss,
  lunaQueryTextCss,
  lunaFiltersHeaderCss,
  lunaChipGroupCss,
  lunaChipWrapperCss,
  lunaQuestionHeaderCss,
  lunaRefineButtonCss,
  toggleWrapperCss,
  lunaQuestionContainerCss,
  lunaPeekingIconWrapperCss,
  lunaTextAreaCss,
} from "./LunaFilterPanel.styles";

export const LunaFilterPanel = ({
  className,
  testId,
}: LunaFilterPanelProps) => {
  const handleChipEvent = () => {
    // TODO: Implement chip event handling when requirements are defined
  };

  const [isLunaEnabled, setIsLunaEnabled] = useState(false);
  const handleToggle = useCallback(() => {
    setIsLunaEnabled((prev) => !prev);
  }, []);

  return (
    <div
      css={lunaFilterPanelContainerCss}
      className={className}
      data-testid={testId || LUNA_FILTER_PANEL_TEST_IDS.CONTAINER}
    >
      <div css={toggleWrapperCss}>
        <AIToggle
          pressed={isLunaEnabled}
          onToggle={handleToggle}
          ariaLabel="Search with Luna"
          labelText="Search with Luna"
          qaSelector="search-with-luna-toggle"
          description="Toggle Search with Luna"
        />
      </div>

      <div css={lunaContentContainerCss}>
        <div css={lunaTagsContainerCss}>
          <AILunaTag enableHoverEffect />
          <AIBetaTag enableHoverEffect />
        </div>

        <div>
          <h5 css={lunaResultsHeaderCss}>25 Most relevant results for:</h5>
          <p css={lunaQueryTextCss}>
            "Articles about American Revolution for 8th grade"
          </p>

          <h5 css={lunaFiltersHeaderCss}>Filters applied by Luna:</h5>

          <ChipGroup
            groupName={LUNA_FILTER_PANEL_TEST_IDS.CHIP_GROUP}
            chipType={ChipGroup.chipTypes.input}
            onChipEvent={handleChipEvent}
            size={ChipGroup.chipSizes.medium}
            __cssFor={lunaChipGroupCss}
          >
            {LUNA_RESULTS_MOCK.map((item) => (
              <div key={item.id} css={lunaChipWrapperCss}>
                <AIChip
                  active
                  text={item.title}
                  value={item.title}
                  dataProps={{
                    "data-qa-selector": `${LUNA_FILTER_PANEL_TEST_IDS.CHIP_PREFIX}${item.id}`,
                    "data-chip-index": String(item.id),
                  }}
                />
              </div>
            ))}
          </ChipGroup>

          <div css={lunaQuestionContainerCss}>
            <h5 css={lunaQuestionHeaderCss}>Question from Luna:</h5>

            <div css={lunaPeekingIconWrapperCss}>
              <LunaPeekingSideIcon aria-hidden />
            </div>

            <TextArea
              __cssFor={lunaTextAreaCss}
              placeholder="e.g., “Culture” or “History”"
              label={`Would you like to refine
your search by adding one
or more topics?`}
              resize="none"
            />
            <AIButton __cssFor={{ root: lunaRefineButtonCss }}>
              Refine search
            </AIButton>
          </div>
        </div>
      </div>
    </div>
  );
};

LunaFilterPanel.displayName = "LunaFilterPanel";
